<div class="page-layout carded fullwidth inner-scroll">

    <!-- TOP BACKGROUND -->
    <div class="top-bg primary"></div>
    <!-- / TOP BACKGROUND -->

    <!-- CENTER -->
    <div class="center" style="width: 100%;">

        <!-- CONTENT HEADER -->
        <div class="header primary p-24" fxLayout="row" fxLayoutAlign="start center">
        </div>
        <!-- / CONTENT HEADER -->
        <!-- CONTENT CARD -->
        <div class="content-card " style="border-color: transparent">

        </div>
        <!-- / CONTENT -->
    </div>
    <!-- / CONTENT CARD -->
    <!-- CONTENT -->
    <div class="content-card" style="margin-top: 2%; margin-left: 5%; margin-right: 15%;">

        <div aling="center">
            <h2>Lista de verificación</h2>

            <h3>Listas de verificación</h3>
            <ul> <a target="_blank" href="./NOM35/wizard/gruia-verificacion-1">Lista 5.1</a></ul>
            <ul><a target="_blank" href="./NOM35/wizard/gruia-verificacion-2">Lista verificación: 5.2; 7.1 a); 7.2; 7.4; 7.5; 7.6, 7.7; 7.8 y 7.9r</a></ul>


        </div><br>
        <div>



        </div><br>


    </div><br><br><br><br><br><br><br><br>

</div>
<!-- / CENTER -->